import { get } from "lodash";
import React from "react";
import SpotifyPlayer from 'react-spotify-player';

import { getIcon } from "../../../helpers/icons";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function Spotify(props) {
    const {
        podcast_code = "",
        apple_podcast_link = "",
        spotify_podcast_link = "",
        amazon_podcast_link = "",
        other_podcast_link = "",
    } = props;

    const size = {
        width: '100%',
        height: 232,
    };
    const view = 'coverart'; // or 'coverart'
    const theme = 'black'; // or 'white'
    const bannerCaption = get(props, "preview_image.caption", "");

    const listenonList = [
        { link: apple_podcast_link, icon: "apple" },
        { link: spotify_podcast_link, icon: "spotify" },
        { link: other_podcast_link, icon: "Podcast" },
        { link: amazon_podcast_link, icon: "Amazon" },
    ]

    return (
        <Section className={style.spotify}>
            <div className={style.spotifyWrap}>
                <div className={style.sectionRow}>
                    {
                        podcast_code !== "" && (
                            <div className={style.sectionHeader}>
                                <div className={style.spotifyPlayerWrap}>
                                    <SpotifyPlayer
                                        uri={podcast_code}
                                        size={size}
                                        view={view}
                                        theme={theme}
                                        allow="encrypted-media *;"
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        listenonList.filter(item => item.link !== null).length > 0 && (
                            <div className={`${style.sectionBody} ${!["", null].includes(bannerCaption) ? "" : style.flexEnd}`}>
                                {
                                    !["", null].includes(bannerCaption) && (
                                        <Title tag="p">{bannerCaption}</Title>
                                    )
                                }
                                <div className={style.listenonListWrap}>
                                    <div className={style.textContent}>
                                        <Title tag="p">Listen on</Title>
                                    </div>
                                    <div className={style.listenonList}>
                                        {
                                            listenonList.map((item, index) => {
                                                if(item.link !== null){
                                                    return (
                                                        <Link
                                                            key={`listenlist_${index}`}
                                                            to={item.link}
                                                        >
                                                            <i className={`${getIcon(item.icon)}`}></i>
                                                        </Link>
                                                    )
                                                }
                                                else {
                                                    return null;
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </Section>
    )
}